import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/Hero';
import { VSL } from './components/VSL';
import { Booking } from './components/Booking';
import { Services } from './components/Services';
import { Commitment } from './components/Commitment';
import { Process } from './components/Process';
import { Testimonials } from './components/Testimonials';
import { Reviews } from './components/Reviews';
import { FAQ } from './components/FAQ';
import { CTA } from './components/CTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-black font-sans selection:bg-amber-400/30 selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <VSL data-id="element-4" />
        <Booking data-id="element-5" />
        <Services data-id="element-6" />
        <Commitment data-id="element-7" />
        <Process data-id="element-8" />
        <Testimonials data-id="element-9" />
        <Reviews data-id="element-10" />
        <FAQ data-id="element-11" />
        <CTA data-id="element-12" />
      </main>
      <Footer data-id="element-13" />
    </div>;
}